
define('tmpl!core/templates/webidl-contiguous/enum-item.html', ['deps/handlebars'], function (hb) { return hb.compile('{{idn indent}}"<a href="#dom-{{parentID}}-{{lname}}" class="idlEnumItem">{{name}}</a>"{{#if needsComma}},{{/if}}\n');});

